package app.alefly.core.config

/**
 * The subset of runtime-config fields whose defaults must fail CLOSED when a
 * client's config fails to load (network error, an unconfigured host such as a
 * raw *.web.app domain, or a malformed payload). Defaulting these to production
 * values sends real analytics events and can target the real Firestore database
 * from an unverified context.
 */
data class UntrustedConfigDefaults(
    val environment: String,
    val analyticsEnabled: Boolean,
    val firestoreDatabase: String,
)

fun resolveUntrustedConfigDefaults(
    rawEnvironment: String?,
    rawAnalyticsEnabled: Boolean?,
    rawFirestoreDatabase: String?,
): UntrustedConfigDefaults = UntrustedConfigDefaults(
    environment = rawEnvironment ?: "unknown",
    analyticsEnabled = rawAnalyticsEnabled ?: false,
    firestoreDatabase = rawFirestoreDatabase ?: "dev",
)
